export default __webpack_public_path__ + "static/media/alert-icon.1db01ee0.png";